export default (array, attribute, value) => {
    const result = array.filter(obj => {
        return obj[`${attribute}`] === value
    })
    return result
}


// WEBPACK FOOTER //
// ./src/helpers/getObjectByAttValue.js